import { Box, Button, Stack, Typography } from "@mui/material";
import { RouterLink } from "src/components/router-link";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { paths } from "src/paths";

const Page = () => {
  usePageView();

  return (
    <>
      <Seo title="404: 페이지를 찾을 수 없습니다" />
      <Box component="main" sx={{ display: "flex", flex: 1, minHeight: 0,
        alignItems: "center", justifyContent: "center", overflow: "auto", p: 3 }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: "center", my: "auto" }}>
          <Typography component="h1" sx={{ fontSize: { xs: 72, md: 112 }, fontWeight: 700, lineHeight: 1 }}>
            404
          </Typography>
          <Typography variant="h5">페이지를 찾을 수 없습니다.</Typography>
          <Typography color="text.secondary">주소를 확인하거나 메뉴에서 원하는 페이지를 선택해 주세요.</Typography>
          <Button component={RouterLink} href={paths.dashboard.home} variant="contained">
            홈으로 이동
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default Page;
